<template >
  <div v-if="tempPasswordIsSend === false">
    <b-card title="Необходима авторизация" class="text-center">
      <b-form @submit.prevent="onLogin">
        <div class="form-group">
          <label for="username">Логин</label>
          <input type="text" v-model="username" name="username" @change="onUpdateUsername" class="form-control" :class="{ 'is-invalid': submitted && !username }" />
          <div v-show="submitted && !username" class="invalid-feedback">Логин не введен</div>
        </div>
        <div class="form-group">
          <label htmlFor="password">Пароль</label>
          <input type="password" v-model="password" name="password" class="form-control" :class="{ 'is-invalid': submitted && !password }" />
          <div v-show="submitted && !password" class="invalid-feedback">Пароль не введен</div>
        </div>

        <b-form-group label="Отправить пароль для входа">
          <b-form-radio-group id="radios1" v-model="senderSelected" :options="senderOptions" name="radioSender">
          </b-form-radio-group>
        </b-form-group>

        <div class="form-group">
          <button class="btn btn-primary" :disabled="logingIn">Отправить</button>
        </div>
      </b-form>
    </b-card>
  </div>

  <div v-else>
    <b-card title="Вам был отправлен пароль для входа" class="text-center">
    <b-form @submit.prevent="onLoginBySecretPassword">
      <div class="form-group">
        <input type="password" v-model="tempPassword" name="tempPassword" class="form-control" />
      </div>
      <div class="form-group">
        <button class="btn btn-primary" :disabled="logingIn">Войти</button>
      </div>
    </b-form>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LoginPage',
  data () {
    return {
      username: '',
      password: '',
      tempPassword: '',
      submitted: false,
      tempPasswordIsSend: false,
      senderSelected: 'email',
      senderOptions: [
        { text: 'Email', value: 'email' },
        { text: 'СМС', value: 'sms' }
      ]
    }
  },
  computed: {
    logingIn () {
      return this.$store.state.isLogin
    }
  },
  methods: {
    onUpdateUsername () {
      this.username = this.username.toLowerCase()
    },
    onLogin (e) {
      this.submitted = true
      this.login()
    },

    login: function () {
      var url = this.$root.$data.baseApiUrl + 'auth/login'

      this.$store.commit('spinnerRun')

      axios.post(url, {
        login: this.username,
        password: this.password,
        type_send_pass: this.senderSelected
      })
        .then(response => {
          if (response.status === 200) {
            console.log(response.data)
            this.$store.commit('login', response.data)
            this.$router.push('requests')
            return
          }
          this.tempPasswordIsSend = true
          console.log(response)
        })
        .catch(error => {
          console.log(error)
          this.tempPasswordIsSend = false
          alert('Неверная пара Логин/Пароль')
        }).then(response => {
          this.$store.commit('spinnerStop')
        })
    },

    onLoginBySecretPassword (e) {
      this.loginBySecretPassword()
    },
    loginBySecretPassword: function () {
      var url = this.$root.$data.baseApiUrl + 'auth/loginBySecretPassword'

      this.$store.commit('spinnerRun')

      axios.post(url, {
        login: this.username,
        password: this.tempPassword
      })
        .then(response => {
          this.tempPasswordIsSend = false
          this.$store.commit('login', response.data)
          this.$router.push('requests')
        })
        .catch(error => {
          console.log(error)
          alert('Неверный пароль или время ожидания истекло')
        }).then(response => {
          this.$store.commit('spinnerStop')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LoginPage.vue